import { LandingNav } from '@/components/landing/LandingNav';
import { LandingHero } from '@/components/landing/LandingHero';
import { LandingProof } from '@/components/landing/LandingProof';
import { LandingFeatures } from '@/components/landing/LandingFeatures';
import { LandingFAQ } from '@/components/landing/LandingFAQ';
import { LandingHowItWorks } from '@/components/landing/LandingHowItWorks';
import { LandingFooter } from '@/components/landing/LandingFooter';

export function LandingPage() {
  return (
    <div className="landing-page">
      <title>Nestra — your entire creative presence</title>
      <LandingNav />
      <main>
        <LandingHero />
        <LandingProof />
        <LandingFeatures />
        <LandingFAQ />
        <LandingHowItWorks />
      </main>
      <LandingFooter />
    </div>
  );
}
